import { Component, Inject, OnInit } from '@angular/core';
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';
import { equipmentMatches } from '@shared/utils/equipment-matches';

export interface LaneEditDialogData {
	originCity: string;
	originState: string;
	destCity: string;
	destState: string;
	equipmentTypes: string[];
}

@Component({
	selector: 'app-lane-edit-dialog',
	templateUrl: './lane-edit-dialog.component.html',
	styleUrls: ['./lane-edit-dialog.component.scss'],
})
export class LaneEditDialogComponent implements OnInit {
	originCity: string = '';
	originState: string = '';
	destCity: string = '';
	destState: string = '';
	equipmentTypes: string[] = [];
	trailerTypes: any[] = [];
	// Compare stored equipment values against `<mat-option>` `dbVal` insensitive
	// to case + separator (so canonical `flatbed`, Title-case `Flatbed`,
	// UPPERCASE `FLATBED`, etc. all match the same dropdown row). See
	// `shared/utils/equipment-matches.ts` for the vocabulary background.
	compareEquipment = equipmentMatches;

	constructor(
		public dialogRef: MatDialogRef<LaneEditDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: LaneEditDialogData,
		private accountSettings: AccountSettingsService
	) {
		this.trailerTypes = this.accountSettings.SEARCHABLE_TRAILER_TYPES;
	}

	ngOnInit() {
		this.originCity = this.data.originCity || '';
		this.originState = this.data.originState || '';
		this.destCity = this.data.destCity || '';
		this.destState = this.data.destState || '';
		this.equipmentTypes = this.data.equipmentTypes || [];
	}

	save() {
		const result: LaneEditDialogData = {
			originCity: this.originCity,
			originState: this.originState,
			destCity: this.destCity,
			destState: this.destState,
			equipmentTypes: this.equipmentTypes,
		};
		this.dialogRef.close(result);
	}

	cancel() {
		this.dialogRef.close(null);
	}
}
